import {FC, useEffect} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {useHoteleria} from '../../../hooks/useHoteleria'
import {TabsContent} from '../../../components/UI/Tab'
import {useAuth} from '../../../hooks/useAuth'
import {getMenuByProfile} from '../../central/services'
import {renderPageWrapper} from './Views/components'
import {arrayMenuHoteleria} from '../components/Layout/SideBar/menu'

const HoteleriaPageWrapper: FC = () => {
  const {tabs, deleteTab, changeTab, currentTab, setMenu} = useHoteleria()
  const {applications, handleApplicationId} = useAuth()

  let totalArrays = tabs.length - 1

  const handleDeleteTab = (event: any, id: number) => {
    event.stopPropagation()
    let key = totalArrays === id ? id - 1 : id
    changeTab(key)
    deleteTab(id)
  }

  const handleCurrentKey = (id: number) => {
    changeTab(id)
  }

  useEffect(() => {
    if (applications.length > 0) {
      const filteredApp = applications.filter((app: any) => app.description === 'Hotelería')[0]
      if (filteredApp) {
        setMenuHoteleria(filteredApp.aplicacionId)
        handleApplicationId(filteredApp.aplicacionId)
      }
    }
  }, [applications])

  const setMenuHoteleria = async (appId: string) => {
    try {
      const {data: res} = await getMenuByProfile(appId)
      if (!res.error) {
        const mergedArr = mergeArrays(arrayMenuHoteleria, res.menu)
        setMenu(mergedArr)
      }
    } catch (error) {}
  }

  const mergeArrays = (menuHoteleria: any[], menu: any[]) => {
    const result: any[] = []
    menuHoteleria.forEach((category) => {
      const matchingCategory = menu.find((item) => item.vista === category.vista)
      if (matchingCategory) {
        // const mergedCategory = { ...category, opciones: matchingCategory.opciones }
        const mergedCategory = {...category}

        mergedCategory.arraySubItem = category.arraySubItem.map((subItem: any) => {
          const matchingSubItem = matchingCategory.vistas.find(
            (item: any) => item.vista === subItem.vista,
          )
          if (matchingSubItem) {
            return {...subItem,vistaId:matchingSubItem.vistaId, opciones: matchingSubItem.opciones}
          }
          return subItem
        })
        result.push(mergedCategory)
      }
    })

    return result
  }

  return (
    <>
      <Tabs
        selectedIndex={currentTab}
        onSelect={(index) => handleCurrentKey(index)}
        className='KHIPU_content_tabs'
      >
        <TabList className={'sdx_tab_panel px-0'}>
          {tabs.map((item, index) => {
            return (
              <Tab key={index} className={'sdx_tab_panel_option'}>
                <TabsContent
                  name={item.title}
                  idIndex={index}
                  idCurrent={Number(currentTab)}
                  closeTab={item.id !== 1}
                  onclickD={(e) => handleDeleteTab(e, index)}
                />
              </Tab>
            )
          })}
        </TabList>
        {tabs.map((item, index) => {
          return <TabPanel key={index}>{renderPageWrapper(item.submenu)}</TabPanel>
        })}
      </Tabs>
    </>
  )
}

export default HoteleriaPageWrapper
